import React from "react";
import { Row, Col, Space, Button, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title } = Typography;

export default function PageHeader({ title, onBack, extra }) {
  return (
    <Row
      align="middle"
      justify="space-between"
      gutter={16}
      style={{ padding: "8px 0" }}
    >
      <Col>
        <Space align="center">
          {onBack && (
            <Button type="text" icon={<ArrowLeftOutlined />} onClick={onBack} />
          )}
          <Title level={4} style={{ margin: 0 }}>
            {title}
          </Title>
        </Space>
      </Col>
      <Col>
        {extra && <Space>{extra}</Space>}
      </Col>
    </Row>
  );
}